import { ArrowRightOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DashedProgressBar from "../../../components/chart-bars/DashedBarProgress";
import UpAudits from "../../upcoming-audits/UpAudits";
import AllCycleModal from "../../../components/modals/AllCycleModal";
import useClientAdmin from "../../../utils/hooks/IsClientAdmin";

const getProgressColor = (progress) => {
  if (progress < 30) return "#C9727B";
  if (progress >= 30 && progress < 60) return "#C6B83F";
  if (progress >= 60 && progress < 80) return "#B4DA1F";
  return "#8DC63F";
};

const OverallView = ({
  overallLoading,
  scoresData,
  selectedQueId,
  handleAuditDateClick,
  showOverallScore,
  showUpcomingAudits,
}) => {
  const navigate = useNavigate();
  const { clientId, isClientAdmin } = useClientAdmin();
  const [showAllCycleModal, setShowAllCycleModal] = useState(false);

  const upcomingAllowedForClient = showUpcomingAudits && clientId !== 166;
  const bothVisible = showOverallScore && upcomingAllowedForClient;
  const colClass = bothVisible ? "col-md-6" : "col-md-12";

  const handleClick = () => setShowAllCycleModal(true);

  const renderBars = () => {
    if (scoresData.length === 0) {
      return (
        <p
          style={{
            fontFamily: "Roboto",
            fontSize: "14px",
            fontWeight: "bold",
            color: "#007dc1",
          }}
        >
          No data available for the selected type.
        </p>
      );
    }
    return scoresData.slice(0, 4)?.map((item) => (
      <div
        key={item.id}
        className="l1 col-sm-6 d-flex justify-content-center align-items-center"
        style={{ cursor: "pointer" }}
        onClick={() =>
          navigate("/reportbrowser", {
            state: {
              questionnaireTypeId: selectedQueId,
              auditCycleId: item.id,
            },
          })
        }
      >
        <DashedProgressBar
          color={getProgressColor(item.get_total_percentage)}
          progress={item.get_total_percentage}
          shadow={true}
          name={item.name}
          reportCount={item?.get_total_audit_stores_count}
        />
      </div>
    ));
  };

  if (!showOverallScore && !upcomingAllowedForClient) return null;

  return (
    <>
      <div className="dashboard-card section1">
        {/* <div className="col-md-6"> */}
        {showOverallScore && (
          <div className={colClass}>
            <div className="upAuditsCard">
              <div className="upAuditsCard-header">
                <p className="upAuditsCard-title">Overall Audit Cycle Score</p>
              </div>
              <div
                className="upAuditsCard-body"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                }}
              >
                <div>
                  <div className="row">
                    {overallLoading ? (
                      <Spin
                        size="medium"
                        style={{ marginTop: "2rem", marginBottom: "2.5rem" }}
                      />
                    ) : (
                      renderBars()
                    )}
                  </div>
                </div>

                {!overallLoading && scoresData.length > 0 && (
                  <div className="view-all-wrap">
                    <button className="view-all-button" onClick={handleClick}>
                      View All Cycle Scores
                      <ArrowRightOutlined className="view-all-arrow" />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {upcomingAllowedForClient && (
          <div className={colClass}>
            <div className="upAuditsCard">
              <div className="upAuditsCard-header">
                <p className="upAuditsCard-title">Upcoming Audits</p>
              </div>
              <div className="upAuditsCard-body">
                {isClientAdmin ? (
                  <UpAudits
                    showDays={false}
                    showMonths={true}
                    showCalender={true}
                    showUpcomingAudits={false}
                    onDateClick={handleAuditDateClick}
                  />
                ) : (
                  <div className="no-audits-message">
                    No calendar access for this account.
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </div>

      <AllCycleModal
        open={showAllCycleModal}
        selectedQueId={selectedQueId}
        onClose={() => setShowAllCycleModal(false)}
      />
    </>
  );
};

export default OverallView;
